import { render, staticRenderFns } from "./ResultManage.vue?vue&type=template&id=717b434c&scoped=true&"
import script from "./ResultManage.vue?vue&type=script&lang=ts&"
export * from "./ResultManage.vue?vue&type=script&lang=ts&"
import style0 from "./ResultManage.vue?vue&type=style&index=0&id=717b434c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b434c",
  null
  
)

export default component.exports